<script setup>
import {useUserStore} from "@/stores/user";
import {storeToRefs} from "pinia";
import {USER_FIELDS} from "../utilities/enums.js";
import {useAppStore} from "@/stores/app.js";
import {URLS_FACTORY} from "@/router/urls.js";
import {computed} from "vue";
import AvatarIcon from "@/components/AvatarIcon.vue";

defineProps({
  size: {
    type: [Number, String],
    default: 50
  }
});

const userStore = useUserStore();
const appStore = useAppStore();
const {initials, fullName, currentUser} = storeToRefs(userStore);

const editProfileLink = computed(() => {
  return URLS_FACTORY.getURL(URLS_FACTORY.URLS_FULL_PATHS.FULL_PROFILE);
});

const pageLabelPrefix = 'dashboard.global.';

function logout(){
  appStore.showSpinner();
  userStore.logout().then(() => {
    appStore.hideSpinner();
  });
}
</script>

<template>
  <v-container class="wrap-user-avatar" fluid>
    <v-row justify="center">
      <v-menu min-width="200px" rounded>
        <template v-slot:activator="{ props }">
          <v-btn icon v-bind="props">
            <avatar-icon :size="size"></avatar-icon>
          </v-btn>
        </template>
        <v-card class="sub-menu">
          <v-card-text>
            <div class="mx-auto text-center">
              <v-avatar>
                <span class="text-h5">{{ initials }}</span>
              </v-avatar>
              <h3>{{ fullName }}</h3>
              <p class="text-caption mt-1">
                {{ currentUser?.[USER_FIELDS.email] }}
              </p>
              <v-divider class="my-3"></v-divider>
              <v-btn
                :to="editProfileLink"
                variant="text">
                {{ $t(pageLabelPrefix + "edit_account") }}
              </v-btn>
              <v-divider class="my-3"></v-divider>
              <v-btn variant="text" @click="logout">
                {{ $t(pageLabelPrefix + "logout") }}
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-menu>
    </v-row>
  </v-container>
</template>

<style lang="less" scoped>
/* Posizione del menu dell'utente a comparsa */
.sub-menu {
  position: relative;
  top: 7px;
}
</style>
